<div class="rounded-2xl bg-red-50 p-10 shadow-sm border border-red-100">
  <h2 class="text-lg font-semibold text-red-800">Something went wrong</h2>
  <p class="text-red-600 mt-1">
    {{surveyRenderStore.renderPayload().errorStatePayload?.errorMessage }}
  </p>
</div>
